export default __webpack_public_path__ + "static/02-qs-world-large-1bd543e6ef0b93d498c2cc98a72bda0d.svg";